export default __webpack_public_path__ + "static/media/LargeSBCTExcessiveMovementEdited.32ee2c12.mp4";